import { create } from 'zustand';

export type ToastTone = 'ok' | 'warn' | 'danger' | 'info';

export interface Toast {
  id: number;
  tone: ToastTone;
  title: string;
  body?: string;
  /** Милисекунди; 0 = стои, докато не се затвори ръчно */
  ttlMs: number;
}

interface ToastState {
  toasts: Toast[];
  push: (toast: Omit<Toast, 'id' | 'ttlMs'> & { ttlMs?: number }) => number;
  dismiss: (id: number) => void;
  clear: () => void;
}

let nextId = 1;

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (toast) => {
    const id = nextId++;
    // Грешките остават на екрана — диспечерът може да гледа настрани в момента.
    const ttlMs = toast.ttlMs ?? (toast.tone === 'danger' ? 0 : 5000);
    set((s) => ({ toasts: [...s.toasts, { ...toast, id, ttlMs }] }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  clear: () => set({ toasts: [] }),
}));

export const toast = {
  ok: (title: string, body?: string) => useToasts.getState().push({ tone: 'ok', title, body }),
  info: (title: string, body?: string) => useToasts.getState().push({ tone: 'info', title, body }),
  warn: (title: string, body?: string) => useToasts.getState().push({ tone: 'warn', title, body }),
  error: (title: string, body?: string) => useToasts.getState().push({ tone: 'danger', title, body }),
};
